import { message } from "antd";
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from "../axios";

export const getServiceCategory = async () => {
  try {
    const res = await axiosGet({
      path: "service-category/list-vendor",
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const getSubServiceCategory = async () => {
  try {
    const res = await axiosGet({
      path: "subservice-category/list",
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const getSsubService = async () => {
  try {
    const uId = localStorage.getItem("userId")

    const res = await axiosGet({
      path: `service/lookup?userId=${uId}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const getSubCategory = async (id) => {
  try {
    const res = await axiosGet({
      path: `subservice-category/list-by-service-category/${id}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const getSubService = async ({ pageNumber, pageSize }) => {
  try {
    const uId = localStorage.getItem("userId")

    const res = await axiosGet({
      path: `service/business/children?pageNumber=${pageNumber}&itemPerPage=${pageSize}&userId=${uId}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const postService = async (payload) => {
  try {
    const uId = localStorage.getItem("userId")

    const res = await axiosPost({
      path: `service?userId=${uId}`,
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const updateService = async (id, payload) => {
  try {
    const res = await axiosPatch({
      path: `service/${id}`,
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const getService = async ({ pageNumber = 1, pageSize = 4 }) => {
  try {
    const uId = localStorage.getItem("userId")

    const res = await axiosGet({
      path: `service/business?pageNumber=${pageNumber}&itemPerPage=${pageSize}&userId=${uId}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const getServiceId = async (id) => {
  try {
    const res = await axiosGet({
      path: `service/${id}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const deleteService = async (id) => {
  try {
    const res = await axiosDelete({
      path: `service/${id}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
